// initial state
const state = () => ({});

// getters
const getters = {
  get(state, getters, rootState, rootGetters) {
    return (service) => {
      //console.log(rootGetters);
      let serviceGetter = service + "/get";
      return rootGetters[serviceGetter](state[service]);
    }
  },
};

// actions
const actions = {
  set(context, payload) {
    context.commit('setCurrent', payload);
  },

  clear(context, service, obj) {
    context.commit('clearCurrent', service, obj);
  },

};

// mutations
const mutations = {
  setCurrent(state, payload) {
    state[payload.service] = payload.id;
  },
  clearCurrent(state, service) {
    delete state[service];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};